import styled from 'styled-components'

export const StyledContentContainer = styled.div`
  margin: ${({theme}) => theme.spacing.lg};
`
